import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { LogOut, User, FileText, Camera, Plane, Phone, ChevronRight, FileSignature, Gavel, Fuel, Bell } from "lucide-react";

const LinkItem = ({ to, icon: Icon, label, hint, soon }) => {
  const inner = (
    <div className="flex items-center gap-3 py-3 border-b border-brand-border last:border-0">
      <div className="w-9 h-9 rounded-lg bg-brand-surface grid place-items-center text-brand-text-muted">
        <Icon className="w-4 h-4" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-sm font-medium text-brand-text">{label}</div>
        <div className="text-[11px] text-brand-text-muted">{hint}</div>
      </div>
      {soon ? (
        <div className="text-[10px] uppercase tracking-wider text-brand-text-muted/70">Soon</div>
      ) : (
        <ChevronRight className="w-4 h-4 text-brand-text-muted/60" />
      )}
    </div>
  );
  return soon ? inner : <Link to={to} data-testid={`more-link-${label.toLowerCase().replace(/\s+/g, "-")}`}>{inner}</Link>;
};

const DriverMore = () => {
  const { user, logout } = useAuth();
  return (
    <div className="p-4 pt-6">
      <div className="text-[10px] uppercase tracking-[0.3em] text-brand-red font-mono">Account</div>
      <h1 className="font-heading text-2xl font-bold tracking-tight text-brand-text mt-1">More</h1>

      <Card className="mt-4 p-4 rounded-2xl border-brand-border">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-xl bg-brand-navy text-white grid place-items-center font-heading font-bold">
            {user?.full_name?.split(" ").map((x) => x[0]).slice(0, 2).join("")}
          </div>
          <div>
            <div className="font-heading font-bold text-brand-text">{user?.full_name}</div>
            <div className="text-[11px] text-brand-text-muted">{user?.email}</div>
          </div>
        </div>
      </Card>

      <Card className="mt-3 p-1 rounded-2xl border-brand-border">
        <div className="px-3">
          <LinkItem to="/driver/holidays" icon={Plane} label="Holiday request" hint="Book time off" />
          <LinkItem to="/driver/contracts" icon={FileSignature} label="My contracts" hint="View & sign your agreements" />
          <LinkItem to="/driver/penalties" icon={Gavel} label="Penalties & disputes" hint="Review charges and dispute unfair ones" />
          <LinkItem to="/driver/fuel" icon={Fuel} label="Fuel receipts" hint="Photograph and submit fuel receipts" />
          <LinkItem to="/driver/upload-issue" icon={Camera} label="Upload evidence" hint="Damage, parcel or signature issue" />
          <LinkItem to="/driver/notifications" icon={Bell} label="Notification chat" hint="Pay alerts and messages from admin" />
          <LinkItem to="/driver/onboarding" icon={FileText} label="Onboarding checklist" hint="Upload required documents" />
          <LinkItem icon={FileText} label="Documents" hint="Licence, DBS, insurance" soon />
          <LinkItem icon={User} label="Profile" hint="Personal details" soon />
          <LinkItem icon={Phone} label="Contact admin" hint="Ask for help" soon />
        </div>
      </Card>

      <Button
        data-testid="driver-logout-btn"
        variant="outline"
        onClick={logout}
        className="w-full mt-6 h-11 border-brand-border gap-2"
      >
        <LogOut className="w-4 h-4" /> Log out
      </Button>
    </div>
  );
};

export default DriverMore;
